import apiPath from "../constants/api-path.constant";

import axios from "../configs/axios-instances";

const followApi = {
  addFollower: ({ payload, success, error }) => {
    const {
      follow: { addFollower },
    } = apiPath;

    axios.postRequest({ path: addFollower, payload, success, error });
  },
  deleteFollower: ({ id, success, error }) => {
    const {
      follow: { deleteFollower },
    } = apiPath;

    axios.deleteRequest({ path: `${deleteFollower}/${id}`, success, error });
  },
  listFollowers:({ success, error }) => {
    const {
      follow: { listFollowers },
    } = apiPath;

    axios.getRequest({ path: listFollowers, success, error });
  }
};

export default followApi;
